var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "black",
    rx: 5,
    ry: 5
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 15,
    y: 15,
    width: 30,
    height: 30,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3828 6.39844L33.8203 6.39844",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6016 10.6172L29.6016 2.17969",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8197 15.539C29.8545 18.4696 29.8625 21.6648 28.8424 24.6005C27.8222 27.5362 25.8344 30.0379 23.2053 31.6951C20.5762 33.3524 17.4618 34.0668 14.3732 33.721C11.2846 33.3752 8.40525 31.9899 6.20765 29.7923C4.01005 27.5947 2.6247 24.7154 2.27894 21.6268C1.93318 18.5382 2.64754 15.4238 4.30479 12.7946C5.96205 10.1655 8.46377 8.17776 11.3994 7.15759C14.3351 6.13742 17.5304 6.14543 20.4609 7.18029",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleIcon);
export default __webpack_public_path__ + "static/media/add-circle-icon.968c77b8d2211c1572f9ecbd5bb34d1c.svg";
export { ForwardRef as ReactComponent };